module.exports = __webpack_public_path__ + "static/media/forgot_password.141cf3f8.svg";